"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingReviewCountText = exports.FilledStars = exports.EmptyStars = exports.StarsWrapper = exports.SummaryStars = exports.AverageRating = exports.RatingsAndReviewsContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.RatingsAndReviewsContainer = styled_1.default.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
`;
exports.AverageRating = styled_1.default.span `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  white-space-collapse: preserve;
`;
exports.SummaryStars = styled_1.default.div `
  margin-right: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
  display: inline-block;
  width: calc(${(props) => props.size * props.ratingScale}px);
  height: ${(props) => props.size}px;
`;
exports.StarsWrapper = styled_1.default.div `
  position: relative;
  width: 100%;
  svg {
    color: ${(0, ui_theme_1.fromTheme)('color_star_ratings')};
  }
`;
exports.EmptyStars = styled_1.default.div `
  position: absolute;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
`;
exports.FilledStars = styled_1.default.div `
  position: absolute;
  width: ${(props) => props.filledPercent};
  white-space: nowrap;
  overflow: hidden;
`;
exports.RatingReviewCountText = styled_1.default.span `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
//# sourceMappingURL=styles.js.map